import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'fei-components',
  template: `
    <p>
      fei-components works!
    </p>
  `,
  styles: ['']
})
export class FeiComponentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
